// Drop the scheme and any trailing slash so a link can be shown as a compact
// label (e.g. "docs.tread.ai", "tread.ai/vendorguide") while the anchor or copy
// action still uses the full URL.
export const toDisplayUrl = (url: string) =>
  url.replace(/^https?:\/\//, '').replace(/\/$/, '');
